import React, {useCallback, useMemo, useState} from 'react';
import ScenarioDelete from './ScenarioDelete';
import {DialogGeneric} from '../../../../core/dialog/DialogGeneric';
import styles from '../VisualizationScenarioAction.module.scss';
import {ScenarioActionProps} from '../../../actionMenuTypes';

export const useScenarioDeleteDialog = () => {
  const [openProps, setOpenProps] = useState<ScenarioActionProps>();
  const handleOnCancel = useCallback(() => {
    setOpenProps(undefined);
  }, []);
  const handleOnSuccess = useCallback(() => {
    setOpenProps(undefined);
    openProps?.onSuccess?.();
  }, [openProps]);

  const Component = useMemo(() => {
    return !openProps ? null : (
      <DialogGeneric open={true} title="Delete Instance" childrenAsText={false} includesDialogActions={true}>
        <div className={styles.dialog}>
          <ScenarioDelete
            model={openProps.model}
            subModel={openProps.subModel}
            scenario={openProps.scenario}
            onSuccess={handleOnSuccess}
            onCancel={handleOnCancel}
          />
        </div>
      </DialogGeneric>
    );
  }, [openProps, handleOnCancel, handleOnSuccess]);

  return {
    open: setOpenProps,
    Component,
  };
};
